import { Item } from '@snack-uikit/breadcrumbs';

import { IconEnDoc } from '@/components/static';
import { SERP_QUERY_PARAMS_NAMES } from '@/constant/serp';
import {
  CategoryDataItem,
  Dictionaries,
  GetSERPFiltersResDocs,
  PlatformsProducts,
  SimpleDictNames,
} from '@/types/serp';

import { equals, isEmpty } from './common';
import { getActualPlatform, GetActualPlatformData } from './platform';

export const getItemBreadcrumbs = ({
  item,
  filters,
  sourcePlatform,
}: Omit<GetActualPlatformData, 'metaPlatform'> & { item: CategoryDataItem }): Item[] => {
  const isEn = equals(item.sourceCode, 'hcdocs');

  const platformLabel = isEn
    ? 'Документация на английском языке'
    : getActualPlatform({ metaPlatform: item.metaFields.meta_platform, filters, sourcePlatform });
  const productLabel = item.metaFields.meta_product;

  return [
    {
      id: platformLabel,
      label: platformLabel,
      icon: isEn ? IconEnDoc : undefined,
    },
    { label: productLabel, id: productLabel },
  ];
};

export const pickProductsByPlatforms = (
  selectedPlatforms?: string[],
  platformsConfig?: PlatformsProducts,
): string[] => {
  if (!platformsConfig) return [];
  if (isEmpty(selectedPlatforms)) return Object.values(platformsConfig).flat();
  return selectedPlatforms.reduce<string[]>((acc, platform) => {
    const platformOptions = platformsConfig[platform as keyof PlatformsProducts];
    if (platformOptions) {
      acc.push(...platformOptions);
    }
    return acc;
  }, []);
};

export const getDictProductsByPlatform = (docsData: GetSERPFiltersResDocs | null): PlatformsProducts | undefined => {
  const DOC_DATA_DICTIONARIES: Record<SimpleDictNames, keyof Dictionaries> = {
    platformsProducts: 'platforms-products',
  };

  if (!docsData?.dictionaries) return;

  return docsData.dictionaries[DOC_DATA_DICTIONARIES.platformsProducts];
};

export const makeReorderProductsFn = (selectedProducts: string[]) => {
  return (a: string, b: string) => {
    const aInSelected = selectedProducts.includes(a);
    const bInSelected = selectedProducts.includes(b);

    if (aInSelected && !bInSelected) {
      return -1;
    }

    if (!aInSelected && bInSelected) {
      return 1;
    }

    return a.localeCompare(b);
  };
};

export const extraUpdateProductsBySelectedPlatform = (
  params: URLSearchParams,
  platformProducts?: PlatformsProducts,
) => {
  const platforms = params.getAll(SERP_QUERY_PARAMS_NAMES.platforms);
  if (isEmpty(platforms)) {
    return params.delete(SERP_QUERY_PARAMS_NAMES.products);
  }

  if (platformProducts) {
    const selectedProducts = params.getAll(SERP_QUERY_PARAMS_NAMES.products);
    const productsBySelectedPlatforms = pickProductsByPlatforms(platforms, platformProducts);
    selectedProducts.forEach(selectedSrv => {
      if (!productsBySelectedPlatforms.includes(selectedSrv)) {
        params.delete(SERP_QUERY_PARAMS_NAMES.products, selectedSrv);
      }
    });
  }
};
